import React from 'react'
import TransactionHistoryPage from '../containers/TransactionHistoryPage'

const TransHistoryPage = () => {
  return (
    <>
        <TransactionHistoryPage/>
    </>
  )
}

export default TransHistoryPage